// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".air-form .el-radio {\n  margin-right: 20px;\n}\n.air-form .frequency {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.air-form .frequency .el-checkbox {\n    margin-right: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
